import { useCreateOrUpdateCollectorInMultipleprint } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FormLayoutElement } from "@/config/forms/general";
import { CollectorInMultipleprint } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const CollectorInMultipleprintDrawer = ({
  fields,
  data,
  queryId,
  type,
  open,
  onOpenChange,
}: {
  fields: FormLayoutElement[] | undefined;
  data: CollectorInMultipleprint;
  queryId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const schema = z.object({
    estampesDansCollectionneursDescriptionInfos: z.string().optional(),
  });

  const { mutate: createOrUpdateCollectorInMultipleprint } =
    useCreateOrUpdateCollectorInMultipleprint(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      estampesDansCollectionneursDescriptionInfos:
        data.estampesDansCollectionneursDescriptionInfos,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateCollectorInMultipleprint({
      id: data.id,
      collectorId: data.collector.id,
      multipleprintId: data.multipleprint.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
      previewImage={{
        attachments: data.multipleprint.attachments ?? [],
        type: "multipleprint",
        alt: data.multipleprint.estampesMultiplesDescriptionNumeroEnregistrement,
      }}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default CollectorInMultipleprintDrawer;
